import React from "react";
import { Box } from "@mui/material";

interface BswLogoProps {
  width?: number;
  height?: number;
}

const BSWLogo: React.FC<BswLogoProps> = ({height = 16 , width}) => {
  return (
    <Box
      component="img"
      src="/images/BSWH_Logo.png"
      alt="Baylor Scott & White Logo"
      sx={{ height, width, resizeMode: 'contain' }}
    />
  );
};

export default BSWLogo;
